'use client';
import { useEffect, useState } from 'react';
function useMediaQuery(query) {
    const [matches, setMatches] = useState(false);
    useEffect(() => {
        if (typeof window === 'undefined')
            return;
        const mediaQueryList = window.matchMedia(query);
        const onChange = (event) => {
            setMatches(event.matches);
        };
        // set initial value
        setMatches(mediaQueryList.matches);
        mediaQueryList.addEventListener('change', onChange);
        return () => mediaQueryList.removeEventListener('change', onChange);
    }, [query]);
    return matches;
}
const DEFAULT_BREAKPOINTS = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
};
export function useBreakpoints(overrides) {
    const bp = {
        ...DEFAULT_BREAKPOINTS,
        ...overrides,
    };
    const smUp = useMediaQuery(`(min-width: ${bp.sm}px)`);
    const mdUp = useMediaQuery(`(min-width: ${bp.md}px)`);
    const lgUp = useMediaQuery(`(min-width: ${bp.lg}px)`);
    const xlUp = useMediaQuery(`(min-width: ${bp.xl}px)`);
    const twoXlUp = useMediaQuery(`(min-width: ${bp['2xl']}px)`);
    return {
        sm: smUp,
        md: mdUp,
        lg: lgUp,
        xl: xlUp,
        '2xl': twoXlUp,
    };
}
